import { observable, runInAction, action } from "mobx";
import { ViewModelBase, FieldType } from "@shoothill/core";
import { FirePointModel } from "./FirePointModel";

export class FirePointViewModel extends ViewModelBase<FirePointModel> {
    constructor(model = new FirePointModel()) {
        super(model);
        this.setDecorators(FirePointModel);
    }
    @action
    public radioChanged = async (value: string, fieldName: string, editable: boolean) => {
        if (!editable) return;
        this.model[fieldName] = value;
        await this.isFieldValid(fieldName as any, value);
    };
    public async isFieldValid(fieldName: keyof FieldType<FirePointModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
